import styled from 'styled-components'
import { StyledButton as Button} from './../Button/styled'
import { theme } from './../../common'

export const StyledButtonList = styled.ul`
    list-style-type: none;
    padding: 0px;
    width: 100%;
    @media screen and (max-width: 991px) {
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
    }
`
export const StyledButtonListItem = styled.li`
    margin: 10px 0px;
    padding: 0px;
    width: 100%;
    @media screen and (max-width: 991px) {
        max-width: 30%;
    }
`

export const StyledButton = styled(Button)`
    padding: 0px;
    border-radius: 5px;
    border: none;
    border: 1px solid ${theme.primary};
    transition: .3s;
    width: 100%;
    display: flex;
    justify-content: center;
    font-size: 1.3em;
    padding: 10px 5%;
    @media screen and (max-width: 767px) {
        padding: 10px 10%;
    }
    i {
        @media screen and (max-width: 767px) {
            flex-basis: 20%;
        }   
        flex-basis: 40%;
        flex-grow: 0;
        /* width: 50%; */
        &:before {
                font-size: 1.3em;
                transition: .3s;
            }
    }
    span {
        flex-grow: 1;
        /* width: 60%; */
        display: flex;
        justify-content: flex-start;
    }
    &:hover {
        background-color: ${theme.white};
        color: ${theme.primary};
        i:before {
            transition: .3s;
            color: ${theme.primary};
        }
    }
`
export const StyledTitle = styled.h1`
    font-size: 3em;
    margin: 5% 0px;
    font-weight: bold;
`